import { FC, useState, createContext, useContext, useCallback } from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
  SituacaoAso,
} from '../../../../../../_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

// A tela só lista ASOs finalizados: o filtro vai sempre no `search`.
const FILTRO_FINALIZADO = `situacaoAso:${SituacaoAso.Finalizado}`

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [state, setState] = useState<QueryState>({
    ...initialQueryRequest.state,
    fixedSort: [{ field: 'termino', order: 'desc' }],
    search: FILTRO_FINALIZADO,
  })

  // Só recompõe o `search` quando ele vem no update; ordenar/paginar mantém a busca atual.
  const updateState = useCallback((updates: Partial<QueryState>) => {
    setState((prev) => ({
      ...prev,
      ...updates,
      search:
        'search' in updates
          ? [FILTRO_FINALIZADO, updates.search].filter(Boolean).join(',')
          : prev.search,
    }))
  }, [])

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
